export const GET_RULE_GROUPS_ALL_REQUEST = 'GET_RULE_GROUPS_ALL_REQUEST';
export const GET_RULE_GROUPS_ALL_SUCCESS = 'GET_RULE_GROUPS_ALL_SUCCESS';
export const GET_RULE_GROUPS_ALL_ERROR = 'GET_RULE_GROUPS_ALL_ERROR';
export const GET_RULE_GROUPS_LIST_REQUEST = 'GET_RULE_GROUPS_LIST_REQUEST';
export const GET_RULE_GROUPS_LIST_SUCCESS = 'GET_RULE_GROUPS_LIST_SUCCESS';
export const GET_RULE_GROUPS_LIST_ERROR = 'GET_RULE_GROUPS_LIST_ERROR';
export const GET_RULE_GROUPS_FULL_LIST = 'GET_RULE_GROUPS_FULL_LIST';
export const ADD_RULE_GROUPS_REQUEST = 'ADD_RULE_GROUPS_REQUEST';
export const ADD_RULE_GROUPS_SUCCESS = 'ADD_RULE_GROUPS_SUCCESS';
export const ADD_RULE_GROUPS_ERROR = 'ADD_RULE_GROUPS_ERROR';
export const ADD_RULE_GROUPS_WITH_RULE_REQUEST =
  'ADD_RULE_GROUPS_WITH_RULE_REQUEST';
export const ADD_RULE_GROUPS_WITH_RULE_SUCCESS =
  'ADD_RULE_GROUPS_WITH_RULE_SUCCESS';
export const ADD_RULE_GROUPS_WITH_RULE_ERROR =
  'ADD_RULE_GROUPS_WITH_RULE_ERROR';
export const GET_RULE_GROUPS_REQUEST = 'GET_RULE_GROUPS_REQUEST';
export const GET_RULE_GROUPS_SUCCESS = 'GET_RULE_GROUPS_SUCCESS';
export const GET_RULE_GROUPS_ERROR = 'GET_RULE_GROUPS_ERROR';
export const UPDATE_RULE_GROUPS_REQUEST = 'UPDATE_RULE_GROUPS_REQUEST';
export const UPDATE_RULE_GROUPS_SUCCESS = 'UPDATE_RULE_GROUPS_SUCCESS';
export const UPDATE_RULE_GROUPS_ERROR = 'UPDATE_RULE_GROUPS_ERROR';

export const PARTIAL_UPDATE_RULE_GROUPS_REQUEST =
  'PARTIAL_UPDATE_RULE_GROUPS_REQUEST';
export const PARTIAL_UPDATE_RULE_GROUPS_SUCCESS =
  'PARTIAL_UPDATE_RULE_GROUPS_SUCCESS';
export const PARTIAL_UPDATE_RULE_GROUPS_ERROR =
  'PARTIAL_UPDATE_RULE_GROUPS_ERROR';

export const DELETE_RULE_GROUPS_REQUEST = 'DELETE_RULE_GROUPS_REQUEST';
export const DELETE_RULE_GROUPS_SUCCESS = 'DELETE_RULE_GROUPS_SUCCESS';
export const DELETE_RULE_GROUPS_ERROR = 'DELETE_RULE_GROUPS_ERROR';
export const SELECT_RULE_GROUPS = 'SELECT_RULE_GROUPS';
export const DESELECT_RULE_GROUPS = 'DESELECT_RULE_GROUPS';

export const REORDER_RULE_GROUPS_REQUEST = 'REORDER_RULE_GROUPS_REQUEST';
export const REORDER_RULE_GROUPS_SUCCESS = 'REORDER_RULE_GROUPS_SUCCESS';
export const REORDER_RULE_GROUPS_ERROR = 'REORDER_RULE_GROUPS_ERROR';

export const SET_EMPTY_RULE_GROUPS = 'SET_EMPTY_RULE_GROUPS';
export const UPDATE_RULE_GROUPS_LIST_OPTIONS =
  'UPDATE_RULE_GROUPS_LIST_OPTIONS';
export const DESELECT_RULE_MATCHED_FILTER_PARAMS =
  'DESELECT_RULE_MATCHED_FILTER_PARAMS';
export const MOVE_RULE_TO_GROUP = 'MOVE_RULE_TO_GROUP';
export const GET_RULE_GROUPS_LIST_TOTAL_COUNT =
  'GET_RULE_GROUPS_LIST_TOTAL_COUNT';
